import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import { composeMixins, mixins } from '../mixins';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';

const { CreativeTemplateMixin, DeliveryContentMixin } = mixins;

const CombinedMixins = composeMixins([
  CreativeTemplateMixin,
  DeliveryContentMixin,
]);

/**
 * 管理百度渠道的数据
 */
export default class BaiduDataSourceController extends CombinedMixins(DataSourceController) {
  /**
   * 获取优化目标列表
   * @param {Object} filtering 过滤条件
   * @returns {Promise<Object[]>}
   */
  async getConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getConvertGoalListApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化目标列表
   * @param {Object} filtering 过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepConvertGoalApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
